import { PAYEX_URL } from 'constants/config';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';
import type {
  ApplyCashbackPayload,
  CalculateCashbackPayload,
  CashbackCalculationResponse,
  CashbackOfferResponse,
  RemoveCashbackPayload,
} from './model';

export type CashbackService = {
  calculate: (
    payload: CalculateCashbackPayload,
  ) => Promise<CashbackCalculationResponse>;
  apply: (payload: ApplyCashbackPayload) => Promise<CashbackOfferResponse>;
  remove: (payload: RemoveCashbackPayload) => Promise<CashbackOfferResponse>;
};

export const cashback: CashbackService = {
  calculate: ({ orderId, token }) => {
    const path = `${PAYEX_URL}/cashback/${orderId}?token=${encodeURIComponent(token)}`;

    return fetchWithAuthentication(path, { method: 'GET' });
  },
  apply: ({ orderId, token }) => {
    const path = `${PAYEX_URL}/cashback/${orderId}`;
    const options = {
      method: 'POST',
      body: JSON.stringify({ token }),
    };

    return fetchWithAuthentication(path, options);
  },
  remove: ({ orderId, token }) => {
    const path = `${PAYEX_URL}/cashback/${orderId}?token=${encodeURIComponent(token)}`;

    return fetchWithAuthentication(path, { method: 'DELETE' });
  },
};
